import { useDispatch, useSelector } from 'react-redux';
import HeaderRates from './header-rates';
import TheadRatesAll from './thead-rates-all';
import TbodyRatesAll from './tbody-rates-all';
import NoRates from './no-rates';
import { useProposalTypeData } from '../../../../../../hooks/proposal/use-proposal-type-data';
import { useProposalComputation } from '../../../../../../hooks/proposal/use-proposal-computation';
import { handleBulkFillSave } from '../../../../../../helper/rates/rates-input-helper';
import { useRateAmountChange } from '../../../../../../hooks/rates/use-rates-amount-change-66-80';
import BulkFillMonthsModal from '../bulk-fill-months-modal';
import InputFormatInfo from '../../../common/input-format-info';
import InputFormatWarning from '../../../common/input-format-warning';
import { setAmountWarning, setBulkData } from '../../../../../../features/actuarial/rates-slice';
import { RootState } from '../../../../../../api/store';

export default function Rate7175() {

    const isLoadingComputeRates = useSelector((state: RootState) =>
        Object.values(state.api.mutations ?? {}).some(
            (mutation: any) => mutation?.endpointName === 'computeRates' && mutation?.status === 'pending' )
    );

    const dispatch = useDispatch();
    const { isNoRates, isRatesIsAgeType } = useProposalTypeData()
    const { 
        isUpdateRates, 
        rates7175,  
        bulkValue, 
        bulkWarning, 
        isBulkFillOpen, 
        selectedMonths,
        amountWarning7175,
        is7175ActiveAgeBracket
    } = useProposalComputation();

    const { handleChangeAmount } = useRateAmountChange({
        rates: rates7175 ?? [],
        typeOfAgeRates: "gcliRates7175",
        typeOfRates: isRatesIsAgeType,
        setAmountWarning: (warning) => dispatch(setAmountWarning({ rateType: "rates7175", warning })),
        startAge: '71',
        endAge: '75',
        ageBracket: '71-75',
    });
    
    if (!rates7175 || rates7175.length === 0) return null;
    
    const ages = rates7175.map(group => group.title);
    const terms = rates7175[0]?.data || [];
    const theadNames = terms.map(item => item.acronym);
    const theadTitles = isRatesIsAgeType ? theadNames : ages

    const tableTitle = isRatesIsAgeType ? `Enrolling Age 71-75` : `Borrowers Age 71-75`
    const firstTheadTitle = isRatesIsAgeType ? `Attained Age` : `Term of Loan`

    const availableMonths = Array.from(new Set(
        rates7175.flatMap((group) => group.data
                .map((item) => item.name || item.acronym)
                .filter((name): name is string => Boolean(name))
        )
    ));

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex min-h-[42px] items-center justify-between gap-2 border-b border-gray-200 bg-[#186cb2]/10 px-3 py-2.5">
                <HeaderRates title={tableTitle} fontSize="text-xs font-semibold text-gray-700" fontWeight="" />
                <div className="flex items-center gap-2">
                    {/* {!isRatesIsAgeType && isUpdateRates && (
                        <button
                            type="button"
                            onClick={() => {
                                dispatch(setBulkData({
                                    bulkWarning: null,
                                    isBulkFillOpen: true,
                                    activeAgeBracket: "71-75",
                                }));
                            }}
                            className="rounded-md border border-[#186cb2]/30 bg-white px-2.5 py-1 text-[10px] font-semibold text-[#186cb2] transition-colors hover:bg-[#186cb2]/10"
                        >
                            Bulk Fill
                        </button>
                    )} */}
                    {isUpdateRates && (
                        <span className="rounded-md border border-[#186cb2]/20 bg-[#186cb2]/10 px-2.5 py-1 text-[10px] font-medium text-[#186cb2]">
                            Editing
                        </span>
                    )}
                </div>
            </div>
            <InputFormatInfo isShow={isUpdateRates} isNoFree={!isRatesIsAgeType}/>
            {isUpdateRates && amountWarning7175 && (
                <InputFormatWarning
                    warningMessage={amountWarning7175}
                    warningClose={() => dispatch(setAmountWarning({ rateType: "rates7175", warning: null }))}
                />
            )}
            <div className="overflow-x-auto">
                <table className="w-full min-w-max border-collapse">
                    {isNoRates ? (
                        <>
                            <NoRates/>
                        </>
                    ) : (
                        <>
                            <TheadRatesAll 
                                theadTitle={theadTitles} 
                                firstTheadTitle={firstTheadTitle}
                            />
                            <TbodyRatesAll 
                                isDisableInput={isLoadingComputeRates}
                                isRatesIsAgeType={isRatesIsAgeType} 
                                tbody={terms} 
                                dataRates={rates7175} 
                                handleChangeAmount={handleChangeAmount} 
                            />
                        </>
                    )}
                </table>
            </div>
            {isBulkFillOpen && is7175ActiveAgeBracket && !isRatesIsAgeType && (
                <BulkFillMonthsModal
                    typeOfAgeBracket="71-75"
                    availableMonths={availableMonths}
                    bulkValue={bulkValue}
                    setBulkValue={(value) => dispatch(setBulkData({bulkValue: value}))}
                    selectedMonths={selectedMonths}
                    setSelectedMonths={(value) => dispatch(setBulkData({ selectedMonths: value }))}
                    bulkWarning={bulkWarning}
                    setBulkWarning={(value) => dispatch(setBulkData({ bulkWarning: value }))}
                    isBulkFillOpen={isBulkFillOpen}
                    setIsBulkFillOpen={(value) => dispatch(setBulkData({ isBulkFillOpen: value }))}
                    handleSaveBulk={() =>
                        handleBulkFillSave( 
                            dispatch,
                            "gcliRates7175",
                            rates7175,
                            isRatesIsAgeType,
                            (value) => dispatch(setBulkData({ isBulkFillOpen: value })),
                            (value) => dispatch(setBulkData({ bulkWarning: value })),
                            (value) => dispatch(setAmountWarning({ rateType: "rates7175", warning: value })),
                            selectedMonths,
                            (value) => dispatch(setBulkData({ selectedMonths: value })),
                            bulkValue,
                            (value) => dispatch(setBulkData({ bulkValue: value })),
                        )
                    }
                />
            )}
        </div>
    )
}